import { Col } from '@opendoor/atoms/box';
import { determinePropertyActionability } from 'components/marketplace/helpers/propertyActionability';
import dynamic from 'next/dynamic';

import { BuyWithConfidence } from '../BuyWithConfidence';
import type { PropertyDetailsType } from '../types';

interface PropertyCTAsProps {
  property: PropertyDetailsType;
}

const BuyDirectCTA = dynamic(() => import('../BuyDirectCTA').then((mod) => mod.BuyDirectCTA), {
  ssr: false,
});

export const PropertyCTAs = ({ property }: PropertyCTAsProps) => {
  const { isActionable, tourKind } = determinePropertyActionability(property);

  if (!isActionable || !tourKind) {
    return null;
  }

  return (
    <Col className="gap-12 px-0 pt-12">
      <BuyDirectCTA property={property} />
      {property.shouldShowGuarantee && <BuyWithConfidence />}
    </Col>
  );
};
